// extracted by mini-css-extract-plugin
export var textInput = "_jn-0";